import { render, staticRenderFns } from "./CharacterModal.vue?vue&type=template&id=6fcf8a80&scoped=true&"
import script from "./CharacterModal.vue?vue&type=script&lang=js&"
export * from "./CharacterModal.vue?vue&type=script&lang=js&"
import style0 from "./CharacterModal.vue?vue&type=style&index=0&id=6fcf8a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcf8a80",
  null
  
)

export default component.exports